import React from "react";

const CatWalkToughSweetOutline = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='692.012'
      height='970.5'
      fillRule='nonzero'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      clipRule='evenodd'
      version='1.1'
      viewBox='0 0 692.012 970.5'
      xmlSpace='preserve'
      className='clickable'
    >
      <clipPath id='ArtboardFrame'>
        <path d='M0 0H2800V2160H0z'></path>
      </clipPath>
      <g
        fill='rgba(0,0,0,0)'
        className='object-glow'
        stroke='#ff5c97'
        strokeLinejoin='round'
        clipPath='url(#ArtboardFrame)'
        transform='translate(-1466.74 -1189.5)'
      >
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1492.24 1296l23 71s-7.5 43.75-19 78-27 59-27 59l20 57s79.25-19.25 136-18 87 26 87 26 1-16.75 9-39 21.25-23.75 23-50-16-55-16-55l-5-33-1-59s-2.25-2-5-3-4 0-4 0l-7 59s-42.02 42.96-70 42c-29-1-107-69-107-69l-26-66s-1.5-.75-6-1-5 1-5 1z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1525.24 1668l1 10s-11 29.5-18 60-10 62-10 62 9.5 9.5 15 21 9 21 9 21l9-1s12.94-39.54 40-47c29-8 52 49 52 49l15-2s-6.09-72.06 37-75c44-3 66 65 66 65l14-1s0-44 19-50c16.27-5.14 37 35 37 35s-8.75-44.5-20-79-25-59-25-59-5.5 7.75-11 10-11-1-11-1-1.75 8.25-5 10-6.25-.75-8-3 1-6 1-6l-9 4s-5.25.75-6-3 3.75-8.5 3-12-6-2-6-2-3 1.25-4-2 0-11 0-11l-82 6s4 6.5 2 8-10-2-10-2l5 16s-5.75 2-10 0-7-8-7-8l5 13s-3 7.5-10 1-18-27-18-27l6 19s.5 6.75-5 2-17-21-17-21z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1559.24 1950s-8.25 18-16 25-18 5-18 5l64 183m156-1s4.82-22.08 30-106c7.29-24.31 15.2-54.9 21.57-86.4 4.12-20.33 7.59-41.05 9.85-60.71 5.98-52.06 4.58-93.89 4.58-93.89'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1573.24 1945c6.1 8.71 16 12.25 35 13s29-8 29-8'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1653.24 1944s19.48 13.34 29 13c23.11-.83 58.67-18.43 61-26'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1759.24 1931s31 11 45-9'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1500.24 1802s-2.46 77.32 8 93c2 3 2-11 25-23'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1541.24 1867s44-32 87-6'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1639.24 1869l28 28c3 3 9.3 2.05 13.15-2.52 12.62-14.95 44.85-43.48 61.85-51.48'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1754.24 1838s33-20 55-14'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1671.24 1303.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1645.24 1307.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1658.24 1305.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1631.24 1307.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1617.24 1306.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1604.24 1302.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1592.24 1297.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1580.24 1292.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1568.24 1286.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1557.24 1279.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1868.24 1212s-17.16 10.28-32.91 18.64c-7.76 4.12-16.46 4.74-20.09 9.36-6.91 8.79-11.75 44-17 83s20 143 49 219c11.17 29.26 17 44 12 60-3.46 11.08 9.84 13.28 9 20-1.9 15.18 1.7 31.16 7.9 41.76 1.99 3.4-4.24 10.79-3.43 14.8.76 3.7 1.59 7.5 2.53 11.44 4.04 16.97-2.54 17.17-2.04 19.26.72 3.09 32.17 28.35 41.04 26.74 11-2 24.83-35.59 41-40 11-3 49.95 44.07 63 39 36-14 132-88.25 137-97s-10-63.25-13-69-2-8.75-6-15-2.75-9-8-15-9.5-2.5-13-9 1.75-9.75-1-17-7.75-3.75-10-12 1.5-11 0-23-5-11.5-6-24 2-17.75 2-30 1-34 1-34-4 13-14 19c-98-17-41-199-41-199s-.14-2.82-29-9c-14-3-16.57-7.84-27-9-21 5-71 177-93 210-4 3-14-8-28-49-14.47-42.38-1-141-1-141z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1901.24 1396l-8 32 52 259 11 8'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M2033.24 1358s-21 22-29 64c-16.42 86.21 56 286 56 286'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M2038.24 1370s-18.27 19.63-24 62c-10 74 55 272 55 272'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M2035.24 1575l72-26'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M2037.24 1585l73-26'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M2046.24 1616l71-26'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M2049.24 1626l71-26'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='1'
          d='M2051.24 1634l71-26'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='3'
          d='M2135.24 1655s-27-115-39-148c0-10 4-8.75 1-19s-13.04-6.26-12-26c1-19-1-52-1-52'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1900.37 1432.3c-.65-4.09 1.18-7.79 4.1-8.25 2.92-.47 5.81 2.47 6.46 6.56.65 4.09-1.18 7.79-4.1 8.25-2.91.47-5.81-2.47-6.46-6.56z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1917.55 1518.3c-.65-4.09 1.18-7.79 4.1-8.25 2.91-.47 5.81 2.47 6.46 6.56.65 4.09-1.18 7.79-4.1 8.25-2.92.47-5.81-2.47-6.46-6.56z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1935.37 1601.3c-.65-4.09 1.18-7.79 4.1-8.25 2.92-.47 5.81 2.47 6.46 6.56.65 4.09-1.18 7.79-4.1 8.25-2.91.47-5.81-2.47-6.46-6.56z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1950.55 1680.3c-.65-4.09 1.18-7.79 4.1-8.25 2.91-.47 5.81 2.47 6.46 6.56.65 4.09-1.18 7.79-4.1 8.25-2.92.47-5.81-2.47-6.46-6.56z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1483.24 1540c122-47 221-20 234 0'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1609.24 1513s12-20 22-19c14.25 1.42 18 20 18 20'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M1554.24 1669s-2 36.5-8 67-11 28.75-16 55-4 50-4 50'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M1621.24 1691l37 79'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M1711.24 1676s-1 67-14 92'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M1553.24 2056s80-8 139-27c59-15 89-4 89-4'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='2'
          d='M1672.24 1900c13 63 22.75 208.5 36 265'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1558.24 1945.5c0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5-4.14 0-7.5-3.36-7.5-7.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1523.24 1843l39 96-31-97'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1638.24 1942.5c0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5-4.14 0-7.5-3.36-7.5-7.5z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1625.24 1843l20 91-10-92'
          opacity='1'
        ></path>
        <path
          strokeLinecap='butt'
          strokeWidth='5'
          d='M1758.08 1927.96a7.505 7.505 0 00-8.88-5.8 7.505 7.505 0 00-5.8 8.88 7.497 7.497 0 008.88 5.8 7.497 7.497 0 005.8-8.88z'
          opacity='1'
        ></path>
        <path
          strokeLinecap='round'
          strokeWidth='5'
          d='M1752.24 1831l-3 91-5-90'
          opacity='1'
        ></path>
      </g>
    </svg>
  );
}

export default CatWalkToughSweetOutline;
